<template>
    <section class="section download-area ptb_100">
        <!-- Shapes Container -->
        <div class="shapes-container d-none d-sm-block">
            <div class="shape-2"></div>
            <div class="shape-3"></div>
        </div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <!-- Download Text -->
                    <div class="download-text text-center">
                        <h2>Download &amp; Subscribe</h2>
                        <p class="my-3">By Rule is the premier college basketball rules app. Officials and learners at all stages can build their rules knowledge by studying regularly. Just fifteen minutes a day can go a long way. Do you have what it takes? Start honing your skills and dowload By Rule today!  </p>
                        <p class="d-none d-sm-block my-3">Subscribe for latest news and rules changes. Get full access to exclusive content and PRO features while enjoying unlimited updates!</p>
                        <!-- Store Buttons -->
                        <div class="button-group store-buttons">
                            <a href="https://apps.apple.com/us/app/by-rule/id1532845521" class="btn btn-bordered">
                                <i class="icofont icofont-brand-apple dsp-tc"></i>
                                <p class="dsp-tc">AVAILABLE ON
                                    <br> <span>Apple Store</span></p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>